import { render } from "./CreateMessageThreadDialog.vue?vue&type=template&id=2fd427e7&scoped=true"
import script from "./CreateMessageThreadDialog.vue?vue&type=script&lang=js"
export * from "./CreateMessageThreadDialog.vue?vue&type=script&lang=js"

import "./CreateMessageThreadDialog.vue?vue&type=style&index=0&id=2fd427e7&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd427e7"]])

export default __exports__